import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import "../0.styles.css";
import { DropDownList } from "../Components/DropDownList";
import { useLocation } from "react-router-dom";
import { addEspaceCharacters, instance } from "../Components/config";
import { DialogAlert } from "../Components/DialogAlert";
import { useAuth } from "../Components/AuthContext";
import { LoaderBox } from "../Components/LoaderBox";

function SubProductoEditar() {
  const { state } = useLocation();
  const { id } = state; // ARREGLAR
  const [isLoading, setLoading] = React.useState(true);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [catalogo, setCatalogo] = React.useState({ Id: "", Nombre: "" });
  const { user } = useAuth();
  const [producto, setProducto] = React.useState({
    catalogo: "",
    id: id,
    nombre: "",
    descripcion: "",
  });
  const [dialog, setDialog] = React.useState({
    title: "",
    text: "",
    redirect: false,
    page: "/SubProductos",
    pageState: {},
  });
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setProducto({
      [name]: value,
    });
  };
  if (isLoading) {
    instance
      .get("/producto/getById/" + id)
      .then((res) => {
        setProducto(res.data);
        setCatalogo({ Id: producto.catalogo, Nombre: "" });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
        setOpenDialog(true);
      })
      .finally(
        setTimeout(() => {
          setLoading(false);
        }, 1000)
      );
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const info = e.target;
    let form = {
      id: id,
      catalogo: catalogo.Id,
      nombre: addEspaceCharacters(info.nombre.value),
      descripcion: addEspaceCharacters(info.descripcion.value),
      userId: user.id,
    };
    instance
      .put("producto/update", form)
      .then((res) => {
        setDialog({
          title: "Actualización exitosa",
          text: `Se han actualizado los datos del producto de forma exitosa.`,
          redirect: true,
          page: "/ProductoDetalle",
          pageState: { id: catalogo.Id },
        });
      })
      .catch((err) => {
        if (err.response.status === 500) {
          setDialog({
            title: "ERROR",
            text: "Existe algún problema con el servidor, por favor inténtalo de nuevo mas tarde, si el problema persiste contáctate con alguno de los encargados.",
          });
        } else {
          setDialog({ title: "ERROR", text: err.response.data.message });
        }
      })
      .finally(setOpenDialog(true));
  };

  return (
    <LoaderBox isLoading={isLoading}>
      <Container
        component="main"
        maxWidth="xs"
        className="bordered-box"
        sx={{
          padding: "4px",
          marginTop: 8,
        }}
      >
        <Grid
          container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            marginTop: 4,
            marginBottom: 4,
          }}
          component="form"
          onSubmit={handleSubmit}
        >
          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <DropDownList
              required
              title="Producto"
              endpoint={"/catalogo/listActiveAndActual/" + producto.catalogo}
              selectedItem={catalogo}
              setSelectedItem={setCatalogo}
              selected={producto.catalogo}
            />
          </Grid>
          <Grid item>
            <TextField
              margin="normal"
              required
              fullWidth
              id="nombre"
              label="Nombre"
              name="nombre"
              value={producto.nombre}
              autoFocus
              inputProps={{ maxLength: 100 }}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid item>
            <TextField
              id="descripcion"
              name="descripcion"
              label="Descripción"
              multiline
              required
              value={producto.descripcion}
              fullWidth
              inputProps={{ maxLength: 250 }}
              onChange={handleInputChange}
              InputLabelProps={{ shrink: true }}
            />
          </Grid>

          <Grid
            item
            sx={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              type="submit"
              size="medium"
              variant="contained"
              sx={{ mt: 3 }}
              color="success"
            >
              Actualizar
            </Button>
          </Grid>
        </Grid>
      </Container>
      <DialogAlert
        title={dialog.title}
        text={dialog.text}
        open={openDialog}
        setOpen={setOpenDialog}
        redirectOnClose={dialog.redirect}
        page={dialog.page}
        pageState={dialog.pageState}
      />
    </LoaderBox>
  );
}

export { SubProductoEditar };
